import React from 'react'
// import Context from '../../context/Context'
// import back from '../../assests/closebutton.svg'
// import model from '../../assests/femimodel.png'
// import femi from '../../assests/femi.png'
import globe from '../../assests/global.png'
import back from '../../assests/arrowLeft.png'
import './Sponsors.css'

const Sponsors = ({ showSponsors, sponserDetails }) => {
  //   const { sponsors } = useContext(Context)

  return (
    <div className=" bg-[#111111] h-[100%] w-[100%] text-white widthController">
      {/* <div className='w-[100%] flex justify-start pr-[10px] absolute z-20'>
                <div className='w-[50px] h-[50px] bg-[#252525] mt-[13px] rounded-full flex items-center justify-center' onClick={() => { showSponsors(false) }}>
                    <img src={back} alt="" />
                </div>
            </div> */}
      <div className="absolute h-[390px] w-[100%] z-50  flex flex-col justify-between">
        <div className="h-[92px] w-[100%] flex items-end px-[20px] linear1">
          <img
            src={back}
            alt=""
            className="h-[24px] w-[24px]"
            onClick={() => {
              showSponsors(false)
            }}
          />
          <span className="font-[16px] font-semibold ml-[16px]">Sponsored</span>
        </div>
        <div className="h-[213px] w-[100%] flex flex-col justify-end pb-[16px] linear2">
          <div className="px-[20px]">
            <span className=" font-[15px] font-medium">
              Event is sponsored by{' '}
            </span>
            <img
              src={sponserDetails?.logo}
              alt=""
              className="h-[80px] w-[80px] mt-[12px] mb-[16px] object-cover"
            />
            <span className=" font-[16px] font-semibold">
              {sponserDetails?.name}
            </span>
          </div>
        </div>
      </div>
      <img
        src={sponserDetails?.coverImage}
        alt=""
        className=" h-[390px] w-[100%] object-cover"
      />
      <div className="px-[20px] text-[12px] pt-[20px]">
        <span className="font-[14px] opacity-[0.6] font-light ">
          {sponserDetails?.about}
        </span>
        <div
          onClick={() => window.open('https://' + sponserDetails?.website)}
          className="h-[37px] w-[190px] bg-[#2A2A2A] rounded-full my-[20px] flex justify-start items-center"
        >
          <img src={globe} alt="" className="h-[19px] w-[19px] m-[9px]" />
          <span>{sponserDetails?.website}</span>
        </div>
        <span className="font-[16px] font-semibold">Sponsored contests</span>
        <div
          onClick={() => window.open('https://www.youthfestival.in/joyalukkas')}
          className="h-[37px] w-[240px] bg-[#2A2A2A] rounded-full my-[20px] flex justify-start items-center"
        >
          <img src={globe} alt="" className="h-[19px] w-[19px] m-[9px]" />
          <span>www.youthfestival.in/joyalukkas</span>
        </div>
      </div>
    </div>
  )
}

export default Sponsors
